import axios from "axios";
import _ from "lodash";

const apiBaseUrl = process.env.API_URL || "https://uqnecjy33i.execute-api.us-east-1.amazonaws.com/prod";

export const setAuthToken = token => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

setAuthToken(localStorage.getItem("token"));

export const requestContact = async data => {
  try {
    const res = await axios.request({
      url: "/email",
      baseURL: apiBaseUrl,
      method: "POST",
      data: data,
    });

    return { success: true, data: res.data };
  } catch (e) {
    const error = _.get(e, "response.data");
    if (error) {
      return { success: false, data: error };
    }
  }
  return { success: false };
};

export const adminLogin = async data => {
  try {
    const res = await axios.request({
      url: "/admin/login",
      baseURL: apiBaseUrl,
      method: "POST",
      data: data,
    });

    return { success: true, data: res.data };
  } catch (e) {
    const error = _.get(e, "response.data");
    if (error) {
      return { success: false, data: error };
    }
  }
  return { success: false };
};

export const getMe = async () => {
  try {
    const res = await axios.request({
      url: "/me",
      baseURL: apiBaseUrl,
      method: "Get",
    });

    return { success: true, data: res.data };
  } catch (e) {
    const error = _.get(e, "response.data");
    if (error) {
      return { success: false, data: error };
    }
  }
  return { success: false };
};

export const createMember = async data => {
  try {
    const res = await axios.request({
      url: "/team",
      baseURL: apiBaseUrl,
      method: "POST",
      data: data,
    });

    return { success: true, data: res.data };
  } catch (e) {
    const error = _.get(e, "response.data");
    if (error) {
      return { success: false, data: error };
    }
  }
  return { success: false };
};

export const getTeam = async () => {
  try {
    const res = await axios.request({
      url: "/team",
      baseURL: apiBaseUrl,
      method: "Get",
    });

    return { success: true, data: res.data };
  } catch (e) {
    const error = _.get(e, "response.data");
    if (error) {
      return { success: false, data: error };
    }
  }
  return { success: false };
};

export const updateMember = async data => {
  try {
    const res = await axios.request({
      url: "/team",
      baseURL: apiBaseUrl,
      method: "PUT",
      data: data,
    });

    return { success: true, data: res.data };
  } catch (e) {
    const error = _.get(e, "response.data");
    if (error) {
      return { success: false, data: error };
    }
  }
  return { success: false };
};

export const deleteMember = async id => {
  try {
    const res = await axios.request({
      url: "/team",
      baseURL: apiBaseUrl,
      method: "DELETE",
      data: { id },
    });

    return { success: true, data: res.data };
  } catch (e) {
    const error = _.get(e, "response.data");
    if (error) {
      return { success: false, data: error };
    }
  }
  return { success: false };
};
